import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { AlertTriangle } from 'lucide-react';

const POINTS = [
  'Investing in small businesses is high risk. You can lose all of the money you put in.',
  'Share prices are fixed at the listed price. Any return shown is a business target, not a promise.',
  'Shares are hard to sell. You only get paid when another investor buys the shares you list, and that may never happen.',
  'Of each new-share purchase, 90% goes to the business owner (95% to Sraivest for Sraivest-owned businesses). 5% comes back to you as cashback.',
  'Sraivest is not a registered broker-dealer or funding portal. Nothing on this site is investment, legal or tax advice.',
];

export const RiskNoticeDialog = ({ open, onClose, onAccept }) => {
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const accept = async () => {
    setSaving(true);
    try { await onAccept(); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#1A1A1A] border-[#F7931A]/40 text-white max-w-lg" data-testid="risk-notice-dialog" data-sb-live>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <AlertTriangle className="w-5 h-5 text-[#F7931A]" /> Before you invest real money
          </DialogTitle>
        </DialogHeader>
        <ul className="space-y-2 text-sm text-gray-300 list-disc pl-5">
          {POINTS.map((p) => <li key={p}>{p}</li>)}
        </ul>
        <label className="flex items-start gap-3 mt-2 text-sm text-white cursor-pointer">
          <Checkbox checked={checked} onCheckedChange={(v) => setChecked(!!v)} data-testid="risk-notice-checkbox" />
          I have read and understand these risks.
        </label>
        <DialogFooter className="gap-2">
          <Button variant="outline" className="btn-secondary" onClick={onClose} data-testid="risk-notice-cancel">Not now</Button>
          <Button className="btn-primary" disabled={!checked || saving} onClick={accept} data-testid="risk-notice-accept">I accept</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
